export default __webpack_public_path__ + "static/family-1ef5ab7c30444cf5e069a0d690f3a401.png";